// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"6634690e","429":"7ac4ebd2","455":"e7b930e8","977":"9fc45374"}[chunkId] + ".chunk.js";
};